import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog}           from '@angular/material/dialog';
import {MatPaginator, PageEvent}              from '@angular/material/paginator';
import {MatSnackBar}                          from '@angular/material/snack-bar';
import {MatTableDataSource}                   from '@angular/material/table';
import {ProductManufacturer}                  from '@src/app/admin/products/models/product.model';
import {ApiService}                           from '@src/app/shared/services/api.service';
import {query}                                from 'js-query-builder';
import {DialogComponent}                      from '@src/app/shared/components/dialog/dialog.component';
import {EditPriceTierModalComponent}          from '../edit-price-tier-modal/edit-price-tier-modal.component';

@Component({
    selector: 'app-additional-price-tier-modal',
    templateUrl: './additional-price-tier-modal.component.html',
    standalone: false,
})
export class AdditionalPriceTierModalComponent implements OnInit
{
    @ViewChild(MatPaginator) public paginator!: MatPaginator;
    public dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
    public displayColumns = ['tier', 'operative_cost', 'subcontractor_cost', 'material_cost', 'sell_price', 'effective_from', 'action'];
    public totalRows: number = 0;
    public pageSize: number = 10;
    public currentPage: number = 0;
    public pageSizeOptions: number[] = [5, 10, 25, 100];

    constructor(
        private apiService: ApiService,
        private snackBar: MatSnackBar,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: { productManufacturer: ProductManufacturer, isDynamicallyPriced: boolean },
    )
    {
    }

    public ngOnInit(): void
    {
        this.loadPrices();
    }

    public loadPrices(): void
    {
        const url = query(`products/prices`)
            .filter('manufacturer_product_id', this.data.productManufacturer.id)
            .filter('by_date', 'future')
            .fields({
                manufacturer_prices: ['id', 'manufacturer_product_id', 'tier', 'operative_cost', 'subcontractor_cost', 'material_cost', 'sell_price', 'effective_from', 'effective_to', 'created_at', 'updated_at']
            })
            .param('page[number]', this?.currentPage + 1)
            .param('page[size]', this?.pageSize)
            .build();

        this.apiService.get(url).subscribe({
            next: response => {
                const responseData = this.data.isDynamicallyPriced ? response.data : response.data.filter(c => c.tier != '0.00');

                this.paginator.pageIndex = this.currentPage;
                this.totalRows = response.meta.total;
                this.dataSource = new MatTableDataSource(responseData);
                this.dataSource._updateChangeSubscription();
            },
            error: error => this.apiService.handleError(error)
        });
    }

    public editPriceTier(priceTier: any): void
    {
        // Open your modal here and pass the priceTier data
        let priceForm = this.dialog.open(EditPriceTierModalComponent, {
            width: '50%',
            data: {
                priceTier: {
                    ...priceTier,
                    manufacturer_id: this.data.productManufacturer?.manufacturer.id,
                    product_id: this.data.productManufacturer?.product.id,
                },
                type: 'edit',
                effectiveFrom: new Date(priceTier.effective_from),
            }
        });

        priceForm.afterClosed().subscribe(result => {
            if (result) {
                this.loadPrices();
            }
        });
    }

    public deletePriceTier(priceTier: any): Promise<void>
    {
        return new Promise<void>((resolve) => {
            const confirmDialogRef = this.dialog.open(DialogComponent, {
                data: {
                    title: 'Delete Price Tier',
                    message: 'Are you sure want to delete this price tier?',
                    type: 'danger',
                    confirmButtonLabel: 'Delete'
                }
            });

            confirmDialogRef.afterClosed().subscribe((confirm) => {
                if (confirm) {
                    this.apiService.post(`products/prices/${priceTier.id}/delete`, {}).subscribe({
                        next: () => {
                            this.snackBar.open('Price tier deleted successfully', 'Close', { duration: 3000, panelClass: ['success-snackbar'] });
                            this.loadPrices();

                            resolve();
                        },
                        error: error => {
                            this.apiService.handleError(error);
                            this.snackBar.open('Failed to delete price tier', 'Close', { duration: 3000, panelClass: ['error-snackbar'] });

                            resolve();
                        }
                    });
                } else {
                    resolve();
                }
            });
        });
    }

    public pageChanged(event: PageEvent): void
    {
        this.pageSize = event.pageSize;
        this.currentPage = event.pageIndex;
        this.loadPrices();
    }
}
